import * as React from "react";
import { EhicFormulierSchemaModel } from "../schema/EhicFormulier";
import { BedanktPagina } from "@cak-legacy/shared-generation-form-flow-overview";
import { translate } from "@klantondersteuning-btl/shared";

type FormSubmittedProps = {
  introBedanktPageText?: React.ReactNode;
  values: EhicFormulierSchemaModel;
}

export const FormSubmitted: React.FunctionComponent<FormSubmittedProps> = (props) => (
  <>
    {props.introBedanktPageText}
    <BedanktPagina
      titel={translate("EhicFormulier")}
      klantContactId={props.values.klantContactId}
      toonMeldingNoteerNummerNaVerzending={false}
      bericht={{
        tekst: translate("UwAanvraagIsVerstuurd"),
        overrideVertaling: true
      }}
    />
  </>
);